import Service from "../service";
import AuthService from "../authService"

const Group = {
    onGetGroup() {
        return Service.get("/getBookGroup");
    },
    getGroupByID(payload) {
        return AuthService.get("/getGroupByID?groupid=" + payload.groupid + "&page=" + payload.page + "&filterid=" + payload.filterid);

    },
    saveFavoriteBook(bookid) {
        return AuthService.post("/saveFavoriteBook", {
            bookid: bookid
        });
    },
    deleteFavoriteBook(bookid) {
        return AuthService.post("/deleteFavoriteBook", {
            bookid: bookid
        });
    },
    downloadBook(id) {
        return AuthService.post("/downloadBook/"+id);

    },
    filterBook(groupid) {
        return AuthService.get('/filterBook?groupid=' + groupid);
    },
    getBookBanner() {
        return Service.get('/bookbanner');
    },
    getEBook(bookid, type_price) {
        return AuthService.post('/getEBook/' + bookid, {
            type_price: type_price
        });
    },
    onSavePaymentEBook(data) {
        return AuthService.post("/submitPaymentEBook", data);
    },

};

export default Group;